// // import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
// // import Checkbox from "../../../Checkbox";
// // import { DotsIcon } from "./MyProjectIcons";
// // import ActionMenuPopover from "./ActionMenuPopover";
// // import DateCalendar from "./DateCalendar"; 

// // // --- Helper Functions ---
// // const getInitials = (name) => {
// //   if (!name) return "?";
// //   if (name.includes("@")) return name.charAt(0).toUpperCase();
// //   const parts = name.trim().split(/\s+/);
// //   if (parts.length >= 2)
// //     return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
// //   return name.charAt(0).toUpperCase();
// // };

// // const formatDate = (dateString) => {
// //   if (!dateString || dateString === "_") return "_";
// //   const date = new Date(dateString);
// //   if (isNaN(date.getTime())) return "_";

// //   const mm = String(date.getMonth() + 1).padStart(2, "0");
// //   const dd = String(date.getDate()).padStart(2, "0");
// //   const yy = String(date.getFullYear()).slice(-2);

// //   return `${mm}-${dd}-${yy}`;
// // };
// // const parseDeadlineDate = (dateString) => {
// //   if (!dateString || dateString === "_" || dateString.trim() === "") return null;
// //   const cleanStr = dateString.trim();

// //   // Handle format: "09/Jan/2026" (DD/MMM/YYYY)
// //   if (cleanStr.match(/^\d{2}\/[a-zA-Z]{3}\/\d{4}$/)) {
// //     const [day, monthStr, year] = cleanStr.split("/");
// //     const monthMap = {
// //       jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
// //       jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12"
// //     };
// //     const monthNum = monthMap[monthStr.toLowerCase()];
// //     if (monthNum) return new Date(`${year}-${monthNum}-${day}T00:00:00`);
// //   }

// //   // Handle format: "16/01/2026" or "02/04/2026" (DD/MM/YYYY)
// //   if (cleanStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
// //     const [day, month, year] = cleanStr.split("/");
// //     return new Date(`${year}-${month}-${day}T00:00:00`);
// //   }

// //   // Fallback
// //   const parsedDate = new Date(cleanStr);
// //   return isNaN(parsedDate.getTime()) ? null : parsedDate;
// // };

// // const formatDeadlineDate = (dateString) => {
// //   const date = parseDeadlineDate(dateString);
// //   if (!date) return "_";

// //   const mm = String(date.getMonth() + 1).padStart(2, "0");
// //   const dd = String(date.getDate()).padStart(2, "0");
// //   const yy = String(date.getFullYear()).slice(-2);

// //   return `${mm}-${dd}-${yy}`;
// // };

// // const formatContractValue = (val) => {
// //   if (!val || val === "_" || val === "") return "_";
// //   return String(val).startsWith("$") ? val : `$${val}`;
// // };

// // const renderStatusPill = (status) => {
// //   let borderCol = "border-gray-300";
// //   let textCol = "text-gray-700";

// //   if (status === "Submitted") {
// //     borderCol = "border-[#8B55DD]";
// //     textCol = "text-[#8B55DD]";
// //   } else if (status === "Missed") {
// //     borderCol = "border-[#BF8C00]";
// //     textCol = "text-[#BF8C00]";
// //   } else if (status === "Win") {
// //     borderCol = "border-[#198808]";
// //     textCol = "text-[#198808]";
// //   } else if (status === "Lost") {
// //     borderCol = "border-[#E21919BF]";
// //     textCol = "text-[#E74746]";
// //   }

// //   return (
// //     <span
// //       className={`status-pill px-3 py-1 rounded-full border ${borderCol} ${textCol} bg-white inline-flex items-center justify-center cursor-pointer hover:shadow-sm transition-all text-[13px] font-medium min-w-[70px]`}
// //     >
// //       {status === "Win" ? "Won" : status}
// //     </span>
// //   );
// // };

// // // --- Dynamic Avatars Component ---
// // const DynamicAvatars = ({ users }) => {
// //   const containerRef = useRef(null);
// //   const [visibleCount, setVisibleCount] = useState(4);

// //   useEffect(() => {
// //     if (!containerRef.current || !users || users.length === 0) return;

// //     const observer = new ResizeObserver((entries) => {
// //       const containerWidth = entries[0].contentRect.width;
// //       let count = 0;
// //       let currentWidth = 0;

// //       for (let i = 0; i < users.length; i++) {
// //         const itemWidth = i === 0 ? 36 : 26;
// //         const morePillWidth = 26;

// //         if (i === users.length - 1) {
// //           if (currentWidth + itemWidth <= containerWidth) {
// //             count++;
// //           }
// //         } else {
// //           if (currentWidth + itemWidth + morePillWidth <= containerWidth) {
// //             count++;
// //             currentWidth += itemWidth;
// //           } else {
// //             break;
// //           }
// //         }
// //       }
// //       setVisibleCount(Math.max(1, count));
// //     });

// //     observer.observe(containerRef.current);
// //     return () => observer.disconnect();
// //   }, [users]);

// //   if (!users || users.length === 0) {
// //     return <span className="text-[#52525B] font-outfit text-[15px] font-medium">_</span>;
// //   }

// //   const visibleUsers = users.slice(0, visibleCount);
// //   const hiddenUsers = users.slice(visibleCount);

// //   return (
// //     <div ref={containerRef} className="flex items-center justify-start w-full min-w-[50px]">
// //       {visibleUsers.map((user, idx) => (
// //         <div
// //           key={idx}
// //           className={`relative group/avatar ${idx !== 0 ? "-ml-2.5" : ""} hover:!z-[9999]`}
// //           style={{ zIndex: 20 - idx }}
// //         >
// //           <div className="w-9 h-9 rounded-full bg-[#C95EBE] flex items-center justify-center text-white font-outfit text-[13px] font-medium border-2 border-white transition-transform hover:scale-105 relative z-10">
// //             {getInitials(user.name)}
// //           </div>
// //           <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/avatar:block z-[99999] min-w-[max-content]">
// //             <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 py-2 px-3 text-center whitespace-nowrap">
// //               <span className="font-outfit text-[#171717] font-medium text-[13px]">
// //                 {user.name} <span className="text-[#C95EBE] ml-1">({user.permission})</span>
// //               </span>
// //             </div>
// //           </div>
// //         </div>
// //       ))}

// //       {hiddenUsers.length > 0 && (
// //         <div className="relative group/more -ml-2.5 hover:!z-[9999]" style={{ zIndex: 10 }}>
// //           <div className="w-9 h-9 rounded-full bg-white border border-[#C95EBE] flex items-center justify-center text-[#171717] font-outfit text-[13px] font-medium transition-transform hover:scale-105 relative z-10">
// //             +{hiddenUsers.length}
// //           </div>
// //           <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/more:block z-[99999] min-w-[max-content]">
// //             <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 p-3 flex flex-col gap-2 whitespace-nowrap">
// //               {hiddenUsers.map((user, idx) => (
// //                 <div key={idx} className="text-left font-outfit text-[#171717] font-medium text-[13px]">
// //                   {user.name} <span className="text-[#C95EBE]">({user.permission})</span>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // // --- Internal Row Component ---
// // const DynamicProjectDataRow = React.memo(({
// //   item,
// //   isSelected,
// //   onToggleSelect,
// //   onRowClick,
// //   onUpdateStatus,
// //   onUpdateContract,
// //   isActionMenuOpen,
// //   onToggleActionMenu,
// //   index,
// //   totalRows,
// //   actionMenuPosition,
// //   setActionMenuRef,
// //   onActionShare,
// //   onActionRename,
// //   onActionDelete,
// //   onActionDetails,
// //   activeColumns,
// //   columnDefs,
// // }) => {
// //   const [isEditingContract, setIsEditingContract] = useState(false);
// //   const [editContractValue, setEditContractValue] = useState("");

// //   const startEditingContract = (e, item) => {
// //     e.stopPropagation();
// //     setIsEditingContract(true);
// //     setEditContractValue(
// //       item.contract_value === "_" ? "" : formatContractValue(item.contract_value)
// //     );
// //   };

// //   const saveContractValue = () => {
// //     setIsEditingContract(false);
// //     if (editContractValue !== formatContractValue(item.contract_value)) {
// //       onUpdateContract(item.id, editContractValue);
// //     }
// //   };

// //   const rowActions = {
// //     isEditingContract,
// //     editContractValue,
// //     setEditContractValue,
// //     saveContractValue,
// //     startEditingContract,
// //     onUpdateStatus,
// //     isSelected,
// //     onToggleSelect,
// //   };

// //   return (
// //     <tr className="cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => onRowClick(item)}>
// //       {activeColumns.map((col) => columnDefs[col.name]?.cell(item, rowActions))}

// //       {/* Actions Cell Fixed Size */}
// //       <td
// //         style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
// //         className="px-3 py-1 relative border-b border-[#0000001A] bg-white text-center"
// //         onClick={(e) => e.stopPropagation()}
// //       >
// //         <div
// //           onClick={(e) => onToggleActionMenu(item, e)}
// //           className="cursor-pointer flex items-center justify-center w-8 h-8 action-button mx-auto rounded hover:bg-gray-100 transition-colors"
// //         >
// //           <DotsIcon />
// //         </div>
// //         {isActionMenuOpen && (
// //           <ActionMenuPopover
// //             position={actionMenuPosition}
// //             menuRef={setActionMenuRef}
// //             onProjectDetails={(e) => { e.stopPropagation(); onActionDetails(item); }}
// //             isLastRow={index >= totalRows - 5 && totalRows > 5}
// //             onShare={(e) => { e.stopPropagation(); onActionShare(item); }}
// //             onRename={(e) => { e.stopPropagation(); e.preventDefault(); onActionRename(item); }}
// //             onDelete={(e) => { e.stopPropagation(); e.preventDefault(); onActionDelete(item); }}
// //           />
// //         )}
// //       </td>
// //     </tr>
// //   );
// // });

// // // --- Main Table Component ---
// // const ProjectDataTable = ({
// //   columnPreferences,
// //   isAllChecked,
// //   handleSelectAll,
// //   filteredProjects,
// //   loading,
// //   currentProjects,
// //   selectedProjects,
// //   handleCheckboxChange,
// //   handleRowClick,
// //   onUpdateStatus,
// //   handleUpdateContractValue,
// //   onUpdateDeadline,
// //   isActionMenuOpen,
// //   toggleActionMenu,
// //   actionMenuPosition,
// //   actionMenuRefs,
// //   handleActionShare,
// //   handleActionRename,
// //   handleActionDelete,
// //   handleActionDetails,
// // }) => {
// //   const [columnWidths, setColumnWidths] = useState(() => {
// //     try {
// //       const savedWidths = localStorage.getItem("projectTable_columnWidths_v2");
// //       return savedWidths ? JSON.parse(savedWidths) : {};
// //     } catch (error) {
// //       return {};
// //     }
// //   });

// //   // --- NEW: Calendar State & Refs ---
// //   const [calendarOpen, setCalendarOpen] = useState(false);
// //   const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
// //   const [editingProject, setEditingProject] = useState(null);
// //   const calendarRef = useRef(null);

// //    // --- NEW: Calendar Handlers ---
// //    const handleOpenCalendar = useCallback((e, item) => {
// //     e.stopPropagation();
// //     e.preventDefault();
// //     const rect = e.currentTarget.getBoundingClientRect();
// //     // Position calendar slightly below the clicked date cell
// //     setCalendarPosition({ 
// //         top: rect.bottom + 5, 
// //         left: rect.left 
// //     });
// //     setEditingProject(item);
// //     setCalendarOpen(true);
// //   }, []);

// //   const handleSaveDate = async (selectedRange) => {
// //     if (!selectedRange.start || !editingProject) return false;
// //     try {
// //       const date = selectedRange.start;
// //       const yyyy = date.getFullYear();
// //       // getMonth() is 0-indexed, so we add 1. padStart ensures 2 digits (e.g., '04')
// //       const mm = String(date.getMonth() + 1).padStart(2, '0');
// //       const dd = String(date.getDate()).padStart(2, '0');

// //       // Standard API format is YYYY-MM-DD. 
// //       // Note: If your backend strictly requires YYYY-DD-MM as you mentioned, change this to `${yyyy}-${dd}-${mm}`
// //       const formattedDate = `${yyyy}-${mm}-${dd}`;
      
// //       if (onUpdateDeadline) {
// //         await onUpdateDeadline(editingProject.id, formattedDate);
// //       }
// //       return true;
// //     } catch (error) {
// //       console.error("Failed to save date", error);
// //       return false;
// //     }
// //   };
// //   // --- NEW: Calendar Click-Outside & Scroll Effects ---
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (calendarOpen && calendarRef.current && !calendarRef.current.contains(event.target)) {
// //         setCalendarOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, [calendarOpen]);

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       if (calendarOpen) setCalendarOpen(false);
// //     };
// //     window.addEventListener('scroll', handleScroll, true);
// //     return () => window.removeEventListener('scroll', handleScroll, true);
// //   }, [calendarOpen]);

// //   const handleResize = useCallback((colName, e) => {
// //     e.preventDefault();
// //     e.stopPropagation();

// //     const thElement = e.target.closest("th");
// //     const startWidth = thElement ? thElement.getBoundingClientRect().width : 150;
// //     const startX = e.clientX;

// //     const onMouseMove = (moveEvent) => {
// //       const minW = colName === "projectName" ? 250 : 120;
// //       const newWidth = Math.max(minW, startWidth + (moveEvent.clientX - startX));
// //       setColumnWidths((prev) => ({ ...prev, [colName]: newWidth }));
// //     };

// //     const onMouseUp = () => {
// //       document.removeEventListener("mousemove", onMouseMove);
// //       document.removeEventListener("mouseup", onMouseUp);
// //       document.body.style.cursor = "default";

// //       setColumnWidths((latestWidths) => {
// //         localStorage.setItem("projectTable_columnWidths_v2", JSON.stringify(latestWidths));
// //         return latestWidths;
// //       });
// //     };

// //     document.addEventListener("mousemove", onMouseMove);
// //     document.addEventListener("mouseup", onMouseUp);
// //     document.body.style.cursor = "col-resize";
// //   }, []);

// //   const getColStyle = useCallback((colName) => {
// //     return columnWidths[colName]
// //       ? {
// //           width: columnWidths[colName],
// //           minWidth: columnWidths[colName],
// //           maxWidth: columnWidths[colName],
// //         }
// //       : {};
// //   }, [columnWidths]);

// //   const defaultCols = [
// //     { name: "name", order: 0, visible: true },
// //     { name: "rfp_status", order: 1, visible: true },
// //     { name: "contract_value", order: 2, visible: true },
// //     { name: "deadline", order: 3, visible: true },
// //     { name: "shared_to", order: 4, visible: true },
// //     { name: "updated_at", order: 5, visible: true },
// //     { name: "created_at", order: 6, visible: true },
// //   ];

// //   const activeColumns = useMemo(() => {
// //     return (columnPreferences && columnPreferences.length > 0 ? columnPreferences : defaultCols)
// //       .filter((col) => col.visible === true || col.visible === "true")
// //       .sort((a, b) => a.order - b.order);
// //   }, [columnPreferences]);

// //   const visibleColCount = activeColumns.length + 1;

// //   // --- STRICT PIXEL WIDTHS FOR DATA COLUMNS ---
// //   // Note: bg-[#F7F7F7] and bg-clip-padding applied to every `th` to prevent bleeding
// //   const columnDefs = useMemo(() => ({
// //     name: {
// //       header: (
// //         <th
// //           key="name"
// //           style={getColStyle("projectName")}
// //           className={`${
// //             !columnWidths.projectName ? "w-full min-w-[250px]" : ""
// //           } rounded-tl-lg bg-[#F7F7F7] bg-clip-padding relative px-3 py-2 text-left text-[#00000080] font-outfit text-[14px] font-semibold  border-r border-[#0000001A]`}
// //         >
// //           <div className="flex items-center gap-3 w-full h-full">
// //             <div className="shrink-0 w-[24px]">
// //               <Checkbox checked={isAllChecked} onChange={handleSelectAll} disabled={filteredProjects.length === 0} showLabel={false} size="md" />
// //             </div>
// //             <span className="truncate block pr-2">Project Name</span>
// //           </div>
// //           <div onMouseDown={(e) => handleResize("projectName", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item, rowActions) => (
// //         <td
// //           key={`name-${item.id}`}
// //           style={getColStyle("projectName")}
// //           className={`${!columnWidths.projectName ? "w-full min-w-[250px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white`}
// //         >
// //           <div className="flex items-center gap-3 w-full h-full min-w-0">
// //             <div className="shrink-0 w-[24px]" onClick={(e) => e.stopPropagation()}>
// //               <Checkbox id={`checkbox-${item.id}`} checked={rowActions.isSelected} onChange={(val, e) => { if (e) e.stopPropagation(); rowActions.onToggleSelect(item.id, item.key); }} disabled={!item.id} showLabel={false} size="md" />
// //             </div>
// //             <span className="truncate block pr-2" title={item.name}>{item.name || "_"}</span>
// //           </div>
// //         </td>
// //       ),
// //     },
// //     rfp_status: {
// //       header: (
// //         <th key="rfp_status" style={getColStyle("status")} className={`${!columnWidths.status ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
// //           Status
// //           <div onMouseDown={(e) => handleResize("status", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item, rowActions) => (
// //         <td key={`rfp_status-${item.id}`} style={getColStyle("status")} className={`${!columnWidths.status ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 border-b border-r border-[#0000001A] bg-white text-left`} onClick={(e) => { e.stopPropagation(); rowActions.onUpdateStatus(item); }}>
// //           {renderStatusPill(item.status)}
// //         </td>
// //       ),
// //     },
// //     contract_value: {
// //       header: (
// //         <th key="contract_value" style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
// //           Contract Value
// //           <div onMouseDown={(e) => handleResize("contractValue", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item, rowActions) => (
// //         <td key={`contract_value-${item.id}`} style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} py-1 text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white text-left`}>
// //           {rowActions.isEditingContract ? (
// //             <input autoFocus type="text" className="w-[85%] px-2 py-1 border border-[#C95EBE] rounded-md outline-none bg-white text-[#171717]" value={rowActions.editContractValue} onChange={(e) => rowActions.setEditContractValue(e.target.value)} onBlur={rowActions.saveContractValue} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.target.blur(); } }} onClick={(e) => e.stopPropagation()} />
// //           ) : (
// //             <div className="w-[85%] px-2 py-1 rounded-md cursor-text hover:bg-[#F4F4F5] transition-colors border border-transparent truncate" onClick={(e) => rowActions.startEditingContract(e, item)}>{formatContractValue(item.contract_value)}</div>
// //           )}
// //         </td>
// //       ),
// //     },
// //     deadline: {
// //       header: (
// //         <th key="deadline" style={getColStyle("bidEndDate")} className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
// //           Bid End Date
// //           <div onMouseDown={(e) => handleResize("bidEndDate", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item) => (
// //         <td 
// //           key={`deadline-${item.id}`} 
// //           style={getColStyle("bidEndDate")} 
// //           className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white cursor-pointer hover:bg-gray-50`}
// //           onClick={(e) => handleOpenCalendar(e, item)}
// //         >
// //           {formatDeadlineDate(item.deadline)} 
// //         </td>
// //       ),
// //     },
// //     shared_to: {
// //       header: (
// //         <th key="shared_to" style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
// //           Shared To
// //           <div onMouseDown={(e) => handleResize("sharedTo", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item) => (
// //         <td key={`shared_to-${item.id}`} style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} px-2 py-1 align-middle border-b border-r border-[#0000001A] bg-white min-w-0 text-left`} onClick={(e) => e.stopPropagation()}>
// //           <DynamicAvatars users={item.shared_to} />
// //         </td>
// //       ),
// //     },
// //     updated_at: {
// //       header: (
// //         <th key="updated_at" style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
// //           Last Edited
// //           <div onMouseDown={(e) => handleResize("lastEdited", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item) => (
// //         <td key={`updated_at-${item.id}`} style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
// //           {formatDate(item.updated_at)}
// //         </td>
// //       ),
// //     },
// //     created_at: {
// //       header: (
// //         <th key="created_at" style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
// //           Created On
// //           <div onMouseDown={(e) => handleResize("createdOn", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
// //         </th>
// //       ),
// //       cell: (item) => (
// //         <td key={`created_at-${item.id}`} style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
// //           {formatDate(item.created_at)}
// //         </td>
// //       ),
// //     },
// //   }), [columnWidths, getColStyle, handleResize, isAllChecked, handleSelectAll, filteredProjects.length, handleOpenCalendar]);

// //   return (
// //     <div className="w-full h-full overflow-auto custom-scrollbar relative">
// //       <table className="w-full min-w-[1200px] table-fixed text-sm text-left border-separate border-spacing-0 relative">
// //         {/* Note: Background removed from thead. It only acts as the sticky structural container now. */}
// //         <thead className="h-10 text-[#1E1E1E] font-medium sticky top-0 z-[100] shadow-[0_1px_0_rgba(0,0,0,0.1)]">
// //           <tr>
// //             {activeColumns.map((col) => columnDefs[col.name]?.header)}

// //             {/* Actions Header Locked */}
// //             <th
// //               style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
// //               className="rounded-tr-lg bg-[#F7F7F7] bg-clip-padding px-3 text-center text-[#00000080] font-outfit text-[15px] font-semibold relative"
// //             >
// //               Actions
// //             </th>
// //           </tr>
// //         </thead>

// //         <tbody className="bg-white">
// //           {loading ? (
// //             <tr>
// //               <td colSpan={visibleColCount} className="py-24 text-center align-middle border-b border-[#0000001A]">
// //                 <div className="flex flex-col items-center justify-center w-full h-full">
// //                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
// //                   <p className="text-[#52525B] font-outfit text-[15px]">Loading Your Projects...</p>
// //                 </div>
// //               </td>
// //             </tr>
// //           ) : filteredProjects.length > 0 ? (
// //             currentProjects.map((item, index) => (
// //               <DynamicProjectDataRow
// //                 key={item.id || index}
// //                 item={item}
// //                 index={index}
// //                 totalRows={currentProjects.length}
// //                 isSelected={selectedProjects.includes(item.id)}
// //                 onToggleSelect={handleCheckboxChange}
// //                 onRowClick={handleRowClick}
// //                 onUpdateStatus={onUpdateStatus}
// //                 onUpdateContract={handleUpdateContractValue}
// //                 isActionMenuOpen={isActionMenuOpen === item.id}
// //                 onToggleActionMenu={toggleActionMenu}
// //                 actionMenuPosition={actionMenuPosition}
// //                 setActionMenuRef={(el) => { if (el) actionMenuRefs.current[item.id] = el; }}
// //                 onActionShare={handleActionShare}
// //                 onActionRename={handleActionRename}
// //                 onActionDelete={handleActionDelete}
// //                 onActionDetails={handleActionDetails}
// //                 activeColumns={activeColumns}
// //                 columnDefs={columnDefs}
// //               />
// //             ))
// //           ) : (
// //             <tr>
// //               <td colSpan={visibleColCount} className="py-10 text-center text-black border-b border-[#0000001A]">
// //                 <img src="/no-contracts.svg" alt="No Data" className="mx-auto mb-2" />
// //                 <p className="text-[16px] font-outfit">Looks like your table is empty!</p>
// //               </td>
// //             </tr>
// //           )}
// //         </tbody>
// //       </table>

// //       {calendarOpen && (
// //         <DateCalendar
// //           isOpen={calendarOpen}
// //           position={calendarPosition}
// //           menuRef={calendarRef}
// //           onClose={() => setCalendarOpen(false)}
// //           onSave={handleSaveDate}
// //           initialDateRange={
// //             editingProject?.deadline && editingProject.deadline !== "_" 
// //               ? { start: parseDeadlineDate(editingProject.deadline) } // <-- Changed here
// //               : null
// //           }
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // export default ProjectDataTable;

// import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
// import Checkbox from "../../../Checkbox";
// import { DotsIcon } from "./MyProjectIcons";
// import ActionMenuPopover from "./ActionMenuPopover";
// import DateCalendar from "./DateCalendar"; 

// // --- Helper Functions ---
// const getInitials = (name) => {
//   if (!name) return "?";
//   if (name.includes("@")) return name.charAt(0).toUpperCase();
//   const parts = name.trim().split(/\s+/);
//   if (parts.length >= 2)
//     return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
//   return name.charAt(0).toUpperCase();
// };

// const formatDate = (dateString) => {
//   if (!dateString || dateString === "_") return "_";
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return "_";

//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   const yy = String(date.getFullYear()).slice(-2);

//   return `${mm}-${dd}-${yy}`;
// };

// const parseDeadlineDate = (dateString) => {
//   if (!dateString || dateString === "_" || dateString.trim() === "") return null;
//   const cleanStr = dateString.trim();

//   // Handle format: "09/Jan/2026" (DD/MMM/YYYY)
//   if (cleanStr.match(/^\d{2}\/[a-zA-Z]{3}\/\d{4}$/)) {
//     const [day, monthStr, year] = cleanStr.split("/");
//     const monthMap = {
//       jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
//       jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12"
//     };
//     const monthNum = monthMap[monthStr.toLowerCase()];
//     if (monthNum) return new Date(`${year}-${monthNum}-${day}T00:00:00`);
//   }

//   // Handle format: "16/01/2026" or "02/04/2026" (DD/MM/YYYY)
//   if (cleanStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
//     const [day, month, year] = cleanStr.split("/");
//     return new Date(`${year}-${month}-${day}T00:00:00`);
//   }

//   // Fallback
//   const parsedDate = new Date(cleanStr);
//   return isNaN(parsedDate.getTime()) ? null : parsedDate;
// };

// const formatDeadlineDate = (dateString) => {
//   const date = parseDeadlineDate(dateString);
//   if (!date) return "_";

//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   const yy = String(date.getFullYear()).slice(-2);

//   return `${mm}-${dd}-${yy}`;
// };

// const formatContractValue = (val) => {
//   if (!val || val === "_" || val === "") return "_";
//   return String(val).startsWith("$") ? val : `$${val}`;
// };

// const renderStatusPill = (status) => {
//   let borderCol = "border-gray-300";
//   let textCol = "text-gray-700";

//   if (status === "Submitted") {
//     borderCol = "border-[#8B55DD]";
//     textCol = "text-[#8B55DD]";
//   } else if (status === "Missed") {
//     borderCol = "border-[#BF8C00]";
//     textCol = "text-[#BF8C00]";
//   } else if (status === "Win") {
//     borderCol = "border-[#198808]";
//     textCol = "text-[#198808]";
//   } else if (status === "Lost") {
//     borderCol = "border-[#E21919BF]";
//     textCol = "text-[#E74746]";
//   }

//   return (
//     <span
//       className={`status-pill px-3 py-1 rounded-full border ${borderCol} ${textCol} bg-white inline-flex items-center justify-center cursor-pointer hover:shadow-sm transition-all text-[13px] font-medium min-w-[70px]`}
//     >
//       {status === "Win" ? "Won" : status}
//     </span>
//   );
// };

// // --- Dynamic Avatars Component ---
// const DynamicAvatars = ({ users }) => {
//   const containerRef = useRef(null);
//   const [visibleCount, setVisibleCount] = useState(4);

//   useEffect(() => {
//     if (!containerRef.current || !users || users.length === 0) return;

//     const observer = new ResizeObserver((entries) => {
//       const containerWidth = entries[0].contentRect.width;
//       let count = 0;
//       let currentWidth = 0;

//       for (let i = 0; i < users.length; i++) {
//         const itemWidth = i === 0 ? 36 : 26;
//         const morePillWidth = 26;

//         if (i === users.length - 1) {
//           if (currentWidth + itemWidth <= containerWidth) {
//             count++;
//           }
//         } else {
//           if (currentWidth + itemWidth + morePillWidth <= containerWidth) {
//             count++;
//             currentWidth += itemWidth;
//           } else {
//             break;
//           }
//         }
//       }
//       setVisibleCount(Math.max(1, count));
//     });

//     observer.observe(containerRef.current);
//     return () => observer.disconnect();
//   }, [users]);

//   if (!users || users.length === 0) {
//     return <span className="text-[#52525B] font-outfit text-[15px] font-medium">_</span>;
//   }

//   const visibleUsers = users.slice(0, visibleCount);
//   const hiddenUsers = users.slice(visibleCount);

//   return (
//     <div ref={containerRef} className="flex items-center justify-start w-full min-w-[50px]">
//       {visibleUsers.map((user, idx) => (
//         <div
//           key={idx}
//           className={`relative group/avatar ${idx !== 0 ? "-ml-2.5" : ""} hover:!z-[9999]`}
//           style={{ zIndex: 20 - idx }}
//         >
//           <div className="w-9 h-9 rounded-full bg-[#C95EBE] flex items-center justify-center text-white font-outfit text-[13px] font-medium border-2 border-white transition-transform hover:scale-105 relative z-10">
//             {getInitials(user.name)}
//           </div>
//           <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/avatar:block z-[99999] min-w-[max-content]">
//             <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 py-2 px-3 text-center whitespace-nowrap">
//               <span className="font-outfit text-[#171717] font-medium text-[13px]">
//                 {user.name} <span className="text-[#C95EBE] ml-1">({user.permission})</span>
//               </span>
//             </div>
//           </div>
//         </div>
//       ))}

//       {hiddenUsers.length > 0 && (
//         <div className="relative group/more -ml-2.5 hover:!z-[9999]" style={{ zIndex: 10 }}>
//           <div className="w-9 h-9 rounded-full bg-white border border-[#C95EBE] flex items-center justify-center text-[#171717] font-outfit text-[13px] font-medium transition-transform hover:scale-105 relative z-10">
//             +{hiddenUsers.length}
//           </div>
//           <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/more:block z-[99999] min-w-[max-content]">
//             <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 p-3 flex flex-col gap-2 whitespace-nowrap">
//               {hiddenUsers.map((user, idx) => (
//                 <div key={idx} className="text-left font-outfit text-[#171717] font-medium text-[13px]">
//                   {user.name} <span className="text-[#C95EBE]">({user.permission})</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // --- Internal Row Component ---
// const DynamicProjectDataRow = React.memo(({
//   item,
//   isSelected,
//   onToggleSelect,
//   onRowClick,
//   onUpdateStatus,
//   onUpdateContract,
//   isActionMenuOpen,
//   onToggleActionMenu,
//   index,
//   totalRows,
//   actionMenuPosition,
//   setActionMenuRef,
//   onActionShare,
//   onActionRename,
//   onActionDelete,
//   onActionDetails,
//   activeColumns,
//   columnDefs,
// }) => {
//   const [isEditingContract, setIsEditingContract] = useState(false);
//   const [editContractValue, setEditContractValue] = useState("");

//   const startEditingContract = (e, item) => {
//     e.stopPropagation();
//     setIsEditingContract(true);
//     setEditContractValue(
//       item.contract_value === "_" ? "" : formatContractValue(item.contract_value)
//     );
//   };

//   const saveContractValue = () => {
//     setIsEditingContract(false);
//     if (editContractValue !== formatContractValue(item.contract_value)) {
//       onUpdateContract(item.id, editContractValue);
//     }
//   };

//   const rowActions = {
//     isEditingContract,
//     editContractValue,
//     setEditContractValue,
//     saveContractValue,
//     startEditingContract,
//     onUpdateStatus,
//     isSelected,
//     onToggleSelect,
//   };

//   return (
//     <tr className="cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => onRowClick(item)}>
//       {activeColumns.map((col) => columnDefs[col.name]?.cell(item, rowActions))}

//       {/* Actions Cell Fixed Size */}
//       <td
//         style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
//         className="px-3 py-1 relative border-b border-[#0000001A] bg-white text-center"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div
//           onClick={(e) => onToggleActionMenu(item, e)}
//           className="cursor-pointer flex items-center justify-center w-8 h-8 action-button mx-auto rounded hover:bg-gray-100 transition-colors"
//         >
//           <DotsIcon />
//         </div>
//         {isActionMenuOpen && (
//           <ActionMenuPopover
//             position={actionMenuPosition}
//             menuRef={setActionMenuRef}
//             onProjectDetails={(e) => { e.stopPropagation(); onActionDetails(item); }}
//             isLastRow={index >= totalRows - 5 && totalRows > 5}
//             onShare={(e) => { e.stopPropagation(); onActionShare(item); }}
//             onRename={(e) => { e.stopPropagation(); e.preventDefault(); onActionRename(item); }}
//             onDelete={(e) => { e.stopPropagation(); e.preventDefault(); onActionDelete(item); }}
//           />
//         )}
//       </td>
//     </tr>
//   );
// });

// // --- Main Table Component ---
// const ProjectDataTable = ({
//   columnPreferences,
//   isAllChecked,
//   handleSelectAll,
//   filteredProjects,
//   loading,
//   currentProjects,
//   selectedProjects,
//   handleCheckboxChange,
//   handleRowClick,
//   onUpdateStatus,
//   handleUpdateContractValue,
//   onUpdateDeadline,
//   isActionMenuOpen,
//   toggleActionMenu,
//   actionMenuPosition,
//   actionMenuRefs,
//   handleActionShare,
//   handleActionRename,
//   handleActionDelete,
//   handleActionDetails,
// }) => {
//   const [columnWidths, setColumnWidths] = useState(() => {
//     try {
//       const savedWidths = localStorage.getItem("projectTable_columnWidths_v2");
//       return savedWidths ? JSON.parse(savedWidths) : {};
//     } catch (error) {
//       return {};
//     }
//   });

//   // --- NEW: Calendar State & Refs ---
//   const [calendarOpen, setCalendarOpen] = useState(false);
//   const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
//   const [editingProject, setEditingProject] = useState(null);
//   const calendarRef = useRef(null);

//    // --- NEW: Calendar Handlers ---
//    const handleOpenCalendar = useCallback((e, item) => {
//     e.stopPropagation();
//     e.preventDefault();
//     const rect = e.currentTarget.getBoundingClientRect();
//     // Position calendar slightly below the clicked date cell
//     setCalendarPosition({ 
//         top: rect.bottom + 5, 
//         left: rect.left 
//     });
//     setEditingProject(item);
//     setCalendarOpen(true);
//   }, []);

//   const handleSaveDate = async (selectedRange) => {
//     if (!selectedRange.start || !editingProject) return false;
//     try {
//       const date = selectedRange.start;
//       const yyyy = date.getFullYear();
//       // getMonth() is 0-indexed, so we add 1. padStart ensures 2 digits (e.g., '04')
//       const mm = String(date.getMonth() + 1).padStart(2, '0');
//       const dd = String(date.getDate()).padStart(2, '0');

//       // Standard API format is YYYY-MM-DD. 
//       // Note: If your backend strictly requires YYYY-DD-MM as you mentioned, change this to `${yyyy}-${dd}-${mm}`
//       const formattedDate = `${yyyy}-${mm}-${dd}`;
      
//       if (onUpdateDeadline) {
//         await onUpdateDeadline(editingProject.id, formattedDate);
//       }
//       return true;
//     } catch (error) {
//       console.error("Failed to save date", error);
//       return false;
//     }
//   };
  
//   // --- NEW: Calendar Click-Outside & Scroll Effects ---
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (calendarOpen && calendarRef.current && !calendarRef.current.contains(event.target)) {
//         setCalendarOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [calendarOpen]);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (calendarOpen) setCalendarOpen(false);
//     };
//     window.addEventListener('scroll', handleScroll, true);
//     return () => window.removeEventListener('scroll', handleScroll, true);
//   }, [calendarOpen]);

//   const handleResize = useCallback((colName, e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     const thElement = e.target.closest("th");
//     const startWidth = thElement ? thElement.getBoundingClientRect().width : 150;
//     const startX = e.clientX;

//     const onMouseMove = (moveEvent) => {
//       const minW = colName === "projectName" ? 250 : 120;
//       const newWidth = Math.max(minW, startWidth + (moveEvent.clientX - startX));
//       setColumnWidths((prev) => ({ ...prev, [colName]: newWidth }));
//     };

//     const onMouseUp = () => {
//       document.removeEventListener("mousemove", onMouseMove);
//       document.removeEventListener("mouseup", onMouseUp);
//       document.body.style.cursor = "default";

//       setColumnWidths((latestWidths) => {
//         localStorage.setItem("projectTable_columnWidths_v2", JSON.stringify(latestWidths));
//         return latestWidths;
//       });
//     };

//     document.addEventListener("mousemove", onMouseMove);
//     document.addEventListener("mouseup", onMouseUp);
//     document.body.style.cursor = "col-resize";
//   }, []);

//   const getColStyle = useCallback((colName) => {
//     return columnWidths[colName]
//       ? {
//           width: columnWidths[colName],
//           minWidth: columnWidths[colName],
//           maxWidth: columnWidths[colName],
//         }
//       : {};
//   }, [columnWidths]);

//   const defaultCols = [
//     { name: "name", order: 0, visible: true },
//     { name: "rfp_status", order: 1, visible: true },
//     { name: "contract_value", order: 2, visible: true },
//     { name: "deadline", order: 3, visible: true },
//     { name: "tags", order: 4, visible: true },
//     { name: "shared_to", order: 5, visible: true },
//     { name: "updated_at", order: 6, visible: true },
//     { name: "created_at", order: 7, visible: true },
//   ];

//   const activeColumns = useMemo(() => {
//     return (columnPreferences && columnPreferences.length > 0 ? columnPreferences : defaultCols)
//       .filter((col) => col.visible === true || col.visible === "true")
//       .sort((a, b) => a.order - b.order);
//   }, [columnPreferences]);

//   const visibleColCount = activeColumns.length + 1;

//   // --- STRICT PIXEL WIDTHS FOR DATA COLUMNS ---
//   // Note: bg-[#F7F7F7] and bg-clip-padding applied to every `th` to prevent bleeding
//   const columnDefs = useMemo(() => ({
//     name: {
//       header: (
//         <th
//           key="name"
//           style={getColStyle("projectName")}
//           className={`${
//             !columnWidths.projectName ? "w-full min-w-[250px]" : ""
//           } rounded-tl-lg bg-[#F7F7F7] bg-clip-padding relative px-3 py-2 text-left text-[#00000080] font-outfit text-[14px] font-semibold  border-r border-[#0000001A]`}
//         >
//           <div className="flex items-center gap-3 w-full h-full">
//             <div className="shrink-0 w-[24px]">
//               <Checkbox checked={isAllChecked} onChange={handleSelectAll} disabled={filteredProjects.length === 0} showLabel={false} size="md" />
//             </div>
//             <span className="truncate block pr-2">Project Name</span>
//           </div>
//           <div onMouseDown={(e) => handleResize("projectName", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item, rowActions) => (
//         <td
//           key={`name-${item.id}`}
//           style={getColStyle("projectName")}
//           className={`${!columnWidths.projectName ? "w-full min-w-[250px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white`}
//         >
//           <div className="flex items-center gap-3 w-full h-full min-w-0">
//             <div className="shrink-0 w-[24px]" onClick={(e) => e.stopPropagation()}>
//               <Checkbox id={`checkbox-${item.id}`} checked={rowActions.isSelected} onChange={(val, e) => { if (e) e.stopPropagation(); rowActions.onToggleSelect(item.id, item.key); }} disabled={!item.id} showLabel={false} size="md" />
//             </div>
//             <span className="truncate block pr-2" title={item.name}>{item.name || "_"}</span>
//           </div>
//         </td>
//       ),
//     },
//     rfp_status: {
//       header: (
//         <th key="rfp_status" style={getColStyle("status")} className={`${!columnWidths.status ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Status
//           <div onMouseDown={(e) => handleResize("status", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item, rowActions) => (
//         <td key={`rfp_status-${item.id}`} style={getColStyle("status")} className={`${!columnWidths.status ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 border-b border-r border-[#0000001A] bg-white text-left`} onClick={(e) => { e.stopPropagation(); rowActions.onUpdateStatus(item); }}>
//           {renderStatusPill(item.status)}
//         </td>
//       ),
//     },
//     contract_value: {
//       header: (
//         <th key="contract_value" style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Contract Value
//           <div onMouseDown={(e) => handleResize("contractValue", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item, rowActions) => (
//         <td key={`contract_value-${item.id}`} style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} py-1 text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white text-left`}>
//           {rowActions.isEditingContract ? (
//             <input autoFocus type="text" className="w-[85%] px-2 py-1 border border-[#C95EBE] rounded-md outline-none bg-white text-[#171717]" value={rowActions.editContractValue} onChange={(e) => rowActions.setEditContractValue(e.target.value)} onBlur={rowActions.saveContractValue} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.target.blur(); } }} onClick={(e) => e.stopPropagation()} />
//           ) : (
//             <div className="w-[85%] px-2 py-1 rounded-md cursor-text hover:bg-[#F4F4F5] transition-colors border border-transparent truncate" onClick={(e) => rowActions.startEditingContract(e, item)}>{formatContractValue(item.contract_value)}</div>
//           )}
//         </td>
//       ),
//     },
//     deadline: {
//       header: (
//         <th key="deadline" style={getColStyle("bidEndDate")} className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Bid End Date
//           <div onMouseDown={(e) => handleResize("bidEndDate", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item) => (
//         <td 
//           key={`deadline-${item.id}`} 
//           style={getColStyle("bidEndDate")} 
//           className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white cursor-pointer hover:bg-gray-50`}
//           onClick={(e) => handleOpenCalendar(e, item)}
//         >
//           {formatDeadlineDate(item.deadline)} 
//         </td>
//       ),
//     },
//     tags: {
//       header: (
//         <th key="tags" style={getColStyle("tags")} className={`${!columnWidths.tags ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Tags
//           <div onMouseDown={(e) => handleResize("tags", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item) => (
//         <td 
//           key={`tags-${item.id}`} 
//           style={getColStyle("tags")} 
//           className={`${!columnWidths.tags ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left border-b border-r border-[#0000001A] bg-white`}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <button
//             type="button"
//             className="px-[12px] py-[4px] rounded-full border border-gray-300 text-[#52525B] font-outfit text-[13px] font-medium bg-white hover:bg-gray-50 transition-colors inline-flex items-center justify-center"
//           >
//             + Add Tag
//           </button>
//         </td>
//       ),
//     },
//     shared_to: {
//       header: (
//         <th key="shared_to" style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Shared To
//           <div onMouseDown={(e) => handleResize("sharedTo", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item) => (
//         <td key={`shared_to-${item.id}`} style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} px-2 py-1 align-middle border-b border-r border-[#0000001A] bg-white min-w-0 text-left`} onClick={(e) => e.stopPropagation()}>
//           <DynamicAvatars users={item.shared_to} />
//         </td>
//       ),
//     },
//     updated_at: {
//       header: (
//         <th key="updated_at" style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
//           Last Edited
//           <div onMouseDown={(e) => handleResize("lastEdited", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item) => (
//         <td key={`updated_at-${item.id}`} style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
//           {formatDate(item.updated_at)}
//         </td>
//       ),
//     },
//     created_at: {
//       header: (
//         <th key="created_at" style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
//           Created On
//           <div onMouseDown={(e) => handleResize("createdOn", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
//         </th>
//       ),
//       cell: (item) => (
//         <td key={`created_at-${item.id}`} style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
//           {formatDate(item.created_at)}
//         </td>
//       ),
//     },
//   }), [columnWidths, getColStyle, handleResize, isAllChecked, handleSelectAll, filteredProjects.length, handleOpenCalendar]);

//   return (
//     <div className="w-full h-full overflow-auto custom-scrollbar relative">
//       <table className="w-full min-w-[1340px] table-fixed text-sm text-left border-separate border-spacing-0 relative">  <thead className="h-10 text-[#1E1E1E] font-medium sticky top-0 z-[100] shadow-[0_1px_0_rgba(0,0,0,0.1)]">
//           <tr>
//             {activeColumns.map((col) => columnDefs[col.name]?.header)}

//             {/* Actions Header Locked */}
//             <th
//               style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
//               className="rounded-tr-lg bg-[#F7F7F7] bg-clip-padding px-3 text-center text-[#00000080] font-outfit text-[15px] font-semibold relative"
//             >
//               Actions
//             </th>
//           </tr>
//         </thead>

//         <tbody className="bg-white">
//           {loading ? (
//             <tr>
//               <td colSpan={visibleColCount} className="py-24 text-center align-middle border-b border-[#0000001A]">
//                 <div className="flex flex-col items-center justify-center w-full h-full">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
//                   <p className="text-[#52525B] font-outfit text-[15px]">Loading Your Projects...</p>
//                 </div>
//               </td>
//             </tr>
//           ) : filteredProjects.length > 0 ? (
//             currentProjects.map((item, index) => (
//               <DynamicProjectDataRow
//                 key={item.id || index}
//                 item={item}
//                 index={index}
//                 totalRows={currentProjects.length}
//                 isSelected={selectedProjects.includes(item.id)}
//                 onToggleSelect={handleCheckboxChange}
//                 onRowClick={handleRowClick}
//                 onUpdateStatus={onUpdateStatus}
//                 onUpdateContract={handleUpdateContractValue}
//                 isActionMenuOpen={isActionMenuOpen === item.id}
//                 onToggleActionMenu={toggleActionMenu}
//                 actionMenuPosition={actionMenuPosition}
//                 setActionMenuRef={(el) => { if (el) actionMenuRefs.current[item.id] = el; }}
//                 onActionShare={handleActionShare}
//                 onActionRename={handleActionRename}
//                 onActionDelete={handleActionDelete}
//                 onActionDetails={handleActionDetails}
//                 activeColumns={activeColumns}
//                 columnDefs={columnDefs}
//               />
//             ))
//           ) : (
//             <tr>
//               <td colSpan={visibleColCount} className="py-10 text-center text-black border-b border-[#0000001A]">
//                 <img src="/no-contracts.svg" alt="No Data" className="mx-auto mb-2" />
//                 <p className="text-[16px] font-outfit">Looks like your table is empty!</p>
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {calendarOpen && (
//         <DateCalendar
//           isOpen={calendarOpen}
//           position={calendarPosition}
//           menuRef={calendarRef}
//           onClose={() => setCalendarOpen(false)}
//           onSave={handleSaveDate}
//           initialDateRange={
//             editingProject?.deadline && editingProject.deadline !== "_" 
//               ? { start: parseDeadlineDate(editingProject.deadline) } // <-- Changed here
//               : null
//           }
//         />
//       )}
//     </div>
//   );
// };

// export default ProjectDataTable;

import React, { useState, useRef, useEffect, useCallback, useMemo, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import Checkbox from "../../../Checkbox";
import { DotsIcon } from "./MyProjectIcons";
import ActionMenuPopover from "./ActionMenuPopover";
import DateCalendar from "./DateCalendar";
import DynamicTags from "./Project Page/DynamicTags";
import ProjectTagModal from "./Project Page/ProjectTagModal";
import useProjectsStore from "../../../store/useProjectsStore";
import { hasNoAccess, canEditRow, isOwnerRow, canTransferOwnership } from "./projectAccess";
import { showSuccessToast } from "../../../utils/toast";
import RequestAccessModal from "./RequestAccessModal";

// --- Helper Functions ---
// Darkens a hex color for readable tag text (mirrors ProjectTagModal).
const darkenColor = (hex, amount = 0.2) => {
  if (!hex || !hex.startsWith("#")) return "#333";
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;
  r = Math.floor(r * (1 - amount));
  g = Math.floor(g * (1 - amount));
  b = Math.floor(b * (1 - amount));
  return `rgb(${r}, ${g}, ${b})`;
};

const getInitials = (name) => {
  if (!name) return "?";
  if (name.includes("@")) return name.charAt(0).toUpperCase();
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2)
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  return name.charAt(0).toUpperCase();
};

const formatDate = (dateString) => {
  if (!dateString || dateString === "_") return "_";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "_";

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);

  return `${mm}-${dd}-${yy}`;
};

const parseDeadlineDate = (dateString) => {
  if (!dateString || dateString === "_" || dateString.trim() === "") return null;
  const cleanStr = dateString.trim();

  // Handle format: "09/Jan/2026" (DD/MMM/YYYY)
  if (cleanStr.match(/^\d{2}\/[a-zA-Z]{3}\/\d{4}$/)) {
    const [day, monthStr, year] = cleanStr.split("/");
    const monthMap = {
      jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
      jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12"
    };
    const monthNum = monthMap[monthStr.toLowerCase()];
    if (monthNum) return new Date(`${year}-${monthNum}-${day}T00:00:00`);
  }

  // Handle format: "16/01/2026" or "02/04/2026" (DD/MM/YYYY)
  if (cleanStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [day, month, year] = cleanStr.split("/");
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // Fallback
  const parsedDate = new Date(cleanStr);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const formatDeadlineDate = (dateString) => {
  const date = parseDeadlineDate(dateString);
  if (!date) return "_";

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);

  return `${mm}-${dd}-${yy}`;
};

// Insert American-style thousands separators (commas) into a numeric string.
// Keeps an optional decimal part and a trailing "." so users can keep typing.
const addThousandsSeparators = (raw) => {
  const trailingDot = raw.endsWith(".") ? "." : "";
  const [intPart, decPart] = raw.replace(/\.+$/, "").split(".");
  const withCommas = (intPart || "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimal = decPart !== undefined ? `.${decPart}` : "";
  return `${withCommas}${decimal}${trailingDot}`;
};

const formatContractValue = (val) => {
  if (!val || val === "_" || val === "") return "_";
  // Strip everything except digits and decimal point, then re-add commas.
  const raw = String(val).replace(/[^0-9.]/g, "");
  if (!raw) return "_";
  return `$${addThousandsSeparators(raw)}`;
};

const renderStatusPill = (status) => {
  let borderCol = "";
  let textCol = "";
  let bgCol = "";

  if (status === "Draft") {
    borderCol = "border-[#CCAB29]";
    textCol = "text-[#CCAB29]";
    bgCol = "bg-[#FCF9ED]";
  } else if (status === "Submitted") {
    borderCol = "border-[#458764]";
    textCol = "text-[#458764]";
    bgCol = "bg-[#F3FAF2]";
  } else if (status === "Win" || status === "Won") {
    borderCol = "border-[#5275BA]";
    textCol = "text-[#5275BA]";
    bgCol = "bg-[#EDF2FC]";
  } else if (status === "Missed") {
    borderCol = "border-[#CC8937]";
    textCol = "text-[#CC8937]";
    bgCol = "bg-[#FFFAF2]";
  } else if (status === "Lost") {
    borderCol = "border-[#B55E5E]";
    textCol = "text-[#B55E5E]";
    bgCol = "bg-[#FFF1ED]";
  } else if (status === "Chose Not to Apply") {
    borderCol = "border-[#8B8B8B]";
    textCol = "text-[#8B8B8B]";
    bgCol = "bg-[#F2F5F7]";
  } else {
    // Custom / unknown statuses render in the purple custom-status color.
    borderCol = "border-[#8B5CF6]";
    textCol = "text-[#8B5CF6]";
    bgCol = "bg-[#F8F3FF]";
  }

  return (
    <span
      className={`status-pill px-4 py-1 rounded-full border ${borderCol} ${textCol} ${bgCol} inline-flex items-center justify-center cursor-pointer hover:opacity-80 transition-all text-[14px] font-semibold max-w-full overflow-hidden w-full`}
    >
      <span className="truncate w-full text-center">
        {status === "Win" ? "Won" : status}
      </span>
    </span>
  );
};

// ─── Row-level permission helpers ──────────────────────────────────────────────
// Owners and editors may edit inline; reviewers are read-only; oversight rows
// are locked entirely and answer any interaction with a toast. The rules live in
// ./projectAccess so this file and MyProjects can't drift apart.

// Column name → the key its manual resize is stored under in `columnWidths`.
// These two differ for historical reasons; the map keeps the width lookup in
// one place instead of repeating the pairing at every call site.
const COLUMN_RESIZE_KEYS = {
  name: "projectName",
  owner: "owner",
  access: "access",
  rfp_status: "status",
  deadline: "bidEndDate",
  project_lead: "projectLead",
  date_submitted: "dateSubmitted",
  contract_value: "contractValue",
  updated_at: "lastEdited",
  tags: "tags",
  shared_to: "sharedTo",
  note: "notes",
  created_at: "createdOn",
  shared_by: "sharedBy",
  shared_on: "sharedOn",
};

// Fallback widths, matching the per-cell `w-[…]` classes below.
const DEFAULT_COL_WIDTHS = {
  name: 280,
  owner: 180,
  access: 130,
  rfp_status: 170,
  deadline: 140,
  project_lead: 200,
  date_submitted: 140,
  contract_value: 150,
  updated_at: 140,
  tags: 220,
  shared_to: 160,
  note: 240,
  created_at: 140,
  shared_by: 190,
  shared_on: 140,
};

const ACTIONS_COL_WIDTH = 80;

// Every column this table knows how to render. Anything else in a user's saved
// preferences is ignored rather than rendered as a blank, mis-counted column.
const KNOWN_COLUMN_NAMES = new Set(Object.keys(COLUMN_RESIZE_KEYS));

const ACCESS_PILL_STYLES = {
  owner: "border-[#C95EBE] text-[#C95EBE] bg-[#FDF4FC]",
  editor: "border-[#458764] text-[#458764] bg-[#F3FAF2]",
  reviewer: "border-[#8B8B8B] text-[#8B8B8B] bg-[#F2F5F7]",
  none: "border-[#D4D4D8] text-[#A1A1AA] bg-[#FAFAFA]",
};

// The My Access cell for a row you can see but can't open.
//
// "No access" was a dead end — true, but it left the only way forward outside
// the product. This asks the owner for you, and remembers that you did.
const RequestAccessCell = ({ item }) => {
  const requestProjectAccess = useProjectsStore((s) => s.requestProjectAccess);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [error, setError] = useState("");
  const status = String(item?.access_request_status || "").toLowerCase();

  const openConfirm = (e) => {
    e.stopPropagation(); // the row itself is clickable
    setError("");
    setConfirmOpen(true);
  };

  // Throws on failure so the dialog can drop its button back to idle and keep
  // the note; on success it stays open just long enough to say "Request sent"
  // and closes itself.
  const send = async (note) => {
    setError("");
    const result = await requestProjectAccess(item.id, note);

    if (!result.ok) {
      setError(result.error);
      throw new Error(result.error);
    }

    // A fresh request needs no toast: the button says "Request sent" and the row
    // settles on "Requested". Only the case those two can't express gets one —
    // the request already existed, so nothing new just happened.
    if (!result.created) {
      const owner = item?.owner?.name || "the owner";
      showSuccessToast(`Already asked for “${item.name}”. ${owner} hasn't answered yet.`, {
        // Per project, so a repeat replaces rather than stacks a duplicate.
        id: `access-request-${item.id}`,
      });
    }
  };

  const confirmModal = (
    <RequestAccessModal
      isOpen={confirmOpen}
      project={item}
      error={error}
      previouslyDenied={status === "denied"}
      onClose={() => {
        setConfirmOpen(false);
        setError("");
      }}
      onConfirm={send}
    />
  );

  // The dialog is rendered in BOTH states on purpose. `requestProjectAccess`
  // flips this row to "pending" optimistically, the instant the request starts —
  // so returning early for "pending" unmounted the dialog mid-send and it
  // vanished without ever showing "Sending…" or "Request sent". It has to
  // outlive the status change that its own submit causes.
  return (
    <>
      {status === "pending" ? (
        <span
          className="px-3 py-0.5 rounded-full border border-[#D4D4D8] text-[#A1A1AA] bg-[#FAFAFA] inline-flex items-center justify-center text-[13px] font-semibold whitespace-nowrap"
          title="Waiting on the owner to answer."
        >
          Requested
        </span>
      ) : (
        <button
          onClick={openConfirm}
          title={
            status === "denied"
              ? "The owner declined last time. You can ask again."
              : `Ask ${item?.owner?.name || "the owner"} for access to this project.`
          }
          className="px-3 py-0.5 rounded-full border border-[#C95EBE] text-[#C95EBE] bg-white hover:bg-[#C95EBE] hover:text-white transition-colors inline-flex items-center justify-center text-[13px] font-semibold whitespace-nowrap"
        >
          {status === "denied" ? "Ask again" : "Request access"}
        </button>
      )}
      {confirmModal}
    </>
  );
};

const renderAccessPill = (item) => {
  if (hasNoAccess(item)) {
    return <RequestAccessCell item={item} />;
  }

  const permission = isOwnerRow(item)
    ? "owner"
    : String(item?.user_permission || "").toLowerCase();

  const styles = ACCESS_PILL_STYLES[permission];
  if (!styles) {
    return <span className="text-[#52525B] font-outfit text-[15px] font-medium">_</span>;
  }

  return (
    <span
      className={`px-3 py-0.5 rounded-full border ${styles} inline-flex items-center justify-center text-[13px] font-semibold whitespace-nowrap`}
    >
      {permission.charAt(0).toUpperCase() + permission.slice(1)}
    </span>
  );
};

// --- Dynamic Avatars Component ---
const DynamicAvatars = ({ users }) => {
  const containerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(4);

  useEffect(() => {
    if (!containerRef.current || !users || users.length === 0) return;

    const observer = new ResizeObserver((entries) => {
      const containerWidth = entries[0].contentRect.width;
      let count = 0;
      let currentWidth = 0;

      for (let i = 0; i < users.length; i++) {
        const itemWidth = i === 0 ? 36 : 26;
        const morePillWidth = 26;

        if (i === users.length - 1) {
          if (currentWidth + itemWidth <= containerWidth) {
            count++;
          }
        } else {
          if (currentWidth + itemWidth + morePillWidth <= containerWidth) {
            count++;
            currentWidth += itemWidth;
          } else {
            break;
          }
        }
      }
      setVisibleCount(Math.max(1, count));
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [users]);

  if (!users || users.length === 0) {
    return <span className="text-[#52525B] font-outfit text-[15px] font-medium">_</span>;
  }

  const visibleUsers = users.slice(0, visibleCount);
  const hiddenUsers = users.slice(visibleCount);

  return (
    <div ref={containerRef} className="flex items-center justify-start w-full min-w-[50px]">
      {visibleUsers.map((user, idx) => (
        <div
          key={idx}
          className={`relative group/avatar ${idx !== 0 ? "-ml-2.5" : ""} hover:!z-[9999]`}
          style={{ zIndex: 20 - idx }}
        >
          <div className="w-9 h-9 rounded-full bg-[#C95EBE] flex items-center justify-center text-white font-outfit text-[13px] font-medium border-2 border-white transition-transform hover:scale-105 relative z-10">
            {getInitials(user.name)}
          </div>
          <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/avatar:block z-[99999] min-w-[max-content]">
            <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 py-2 px-3 text-center whitespace-nowrap">
              <span className="font-outfit text-[#171717] font-medium text-[13px]">
                {user.name} <span className="text-[#C95EBE] ml-1">({user.permission})</span>
              </span>
            </div>
          </div>
        </div>
      ))}

      {hiddenUsers.length > 0 && (
        <div className="relative group/more -ml-2.5 hover:!z-[9999]" style={{ zIndex: 10 }}>
          <div className="w-9 h-9 rounded-full bg-white border border-[#C95EBE] flex items-center justify-center text-[#171717] font-outfit text-[13px] font-medium transition-transform hover:scale-105 relative z-10">
            +{hiddenUsers.length}
          </div>
          <div className="absolute top-[110%] left-1/2 -translate-x-1/2 hidden group-hover/more:block z-[99999] min-w-[max-content]">
            <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] border border-gray-100 p-3 flex flex-col gap-2 whitespace-nowrap">
              {hiddenUsers.map((user, idx) => (
                <div key={idx} className="text-left font-outfit text-[#171717] font-medium text-[13px]">
                  {user.name} <span className="text-[#C95EBE]">({user.permission})</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- Project Lead Cell ---
// Legacy org role "member" maps to the new "editor" permission.
const normalizeLeadRole = (role) =>
  (role || "").toLowerCase() === "member" ? "editor" : role;

// Label shown next to each member. Org admins (role "Admin") are surfaced as
// "Admin" rather than the backend's "Owner" permission_role; everyone else uses
// their normalized permission_role.
const leadRoleLabel = (member) =>
  (member?.role || "").toLowerCase() === "admin"
    ? "Admin"
    : normalizeLeadRole(member?.permission_role);

// The dropdown lists editors, admins and members (shown as editor); reviewers
// are read-only and are not offered as a lead, and the workspace owner is hidden
// (they already own every project).
const isLeadEligible = (member) =>
  (member?.permission_role || "").toLowerCase() !== "reviewer" &&
  !member?.is_owner;

// `members` is the org member list, `canManage` gates whether the current user
// (admin/owner) may open the dropdown, and `onPick(member)` shares + sets the lead.
const ProjectLeadCell = ({ value, members = [], canManage = false, onPick, isApplying = false }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);
  const menuRef = useRef(null);
  // Fixed-position coords for the portalled menu (escapes table overflow clipping).
  const [menuPos, setMenuPos] = useState(null);

  const MENU_WIDTH = 280;
  const MENU_MAX_HEIGHT = 252; // search box (~50) + list (max 200) + padding

  // Compute the menu's fixed position from the trigger, flipping up when
  // there isn't enough room below (handles bottom rows of the table).
  const updateMenuPos = useCallback(() => {
    const trigger = ref.current;
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openUp = spaceBelow < MENU_MAX_HEIGHT + 8 && spaceAbove > spaceBelow;

    // Keep the menu within the viewport horizontally.
    let left = rect.left;
    if (left + MENU_WIDTH > window.innerWidth - 8) {
      left = Math.max(8, window.innerWidth - MENU_WIDTH - 8);
    }

    setMenuPos({
      left,
      top: openUp ? undefined : rect.bottom + 4,
      bottom: openUp ? window.innerHeight - rect.top + 4 : undefined,
      maxHeight: openUp
        ? Math.min(MENU_MAX_HEIGHT, spaceAbove - 12)
        : Math.min(MENU_MAX_HEIGHT, spaceBelow - 12),
    });
  }, []);

  useLayoutEffect(() => {
    if (!open) return;
    updateMenuPos();
  }, [open, updateMenuPos]);

  // Reposition while open if the page scrolls or resizes; close on outside click.
  useEffect(() => {
    if (!open) return;
    const onDocMouseDown = (e) => {
      if (
        ref.current && !ref.current.contains(e.target) &&
        menuRef.current && !menuRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    const onReposition = () => updateMenuPos();
    document.addEventListener("mousedown", onDocMouseDown);
    window.addEventListener("scroll", onReposition, true);
    window.addEventListener("resize", onReposition);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
      window.removeEventListener("scroll", onReposition, true);
      window.removeEventListener("resize", onReposition);
    };
  }, [open, updateMenuPos]);

  // Reset the search field whenever the dropdown closes.
  useEffect(() => {
    if (!open) setSearch("");
  }, [open]);

  // While the lead is being set/updated (incl. the share/ call), show a simple
  // pulsing "Applying…" text in the column's data text color.
  if (isApplying) {
    return (
      <span className="font-outfit text-[14px] font-medium text-[#171717] animate-pulse cursor-default">
        Applying…
      </span>
    );
  }

  const current = value && String(value).trim() ? String(value).trim() : "";

  const handleSelect = (member) => {
    setOpen(false);
    if (onPick) onPick(member);
  };

  const eligibleMembers = members.filter(isLeadEligible);
  const filteredMembers = eligibleMembers.filter((m) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      (m.full_name || "").toLowerCase().includes(q) ||
      (m.email || "").toLowerCase().includes(q)
    );
  });

  return (
    <div ref={ref} className="relative w-full" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => canManage && setOpen((p) => !p)}
        disabled={!canManage}
        title={canManage ? "" : "Only admins/owners can set the project lead"}
        className={`w-full flex items-center justify-between gap-2 px-3 py-1.5 rounded-md border bg-white text-[14px] font-medium transition-colors ${
          open ? "border-[#C95EBE]" : "border-[#0000001A]"
        } ${canManage ? "hover:border-[#C95EBE] cursor-pointer" : "cursor-not-allowed opacity-70"}`}
      >
        <span className={`truncate ${current ? "text-[#171717]" : "text-[#71717A]"}`}>
          {current || "Set Lead"}
        </span>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 text-[#71717A] transition-transform ${open ? "rotate-180" : ""}`}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && canManage && menuPos && createPortal(
        <div
          ref={menuRef}
          style={{
            position: "fixed",
            left: menuPos.left,
            top: menuPos.top,
            bottom: menuPos.bottom,
            width: MENU_WIDTH,
            maxHeight: menuPos.maxHeight,
          }}
          className="flex flex-col bg-white rounded-md shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 z-[1000] overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Fixed Search Field */}
          <div className="p-2 border-b border-gray-100 bg-white shrink-0">
            <div className="relative flex items-center">
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="absolute left-2.5 text-[#71717A]"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search members"
                onClick={(e) => e.stopPropagation()}
                className="w-full pl-8 pr-3 py-1.5 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] transition-colors"
                style={{ fontSize: "13px", lineHeight: "18px" }}
              />
            </div>
          </div>

          {/* Scrollable Member List */}
          <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar py-1">
            {filteredMembers.length > 0 ? (
              filteredMembers.map((member, index) => (
                <button
                  key={member.user_id || index}
                  type="button"
                  onClick={() => handleSelect(member)}
                  className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-[#F8F3FF] transition-colors text-left"
                >
                  <div className="w-7 h-7 rounded-full bg-[#C95EBE] flex items-center justify-center !text-white font-semibold text-[11px] flex-shrink-0">
                    {member.full_name
                      ? member.full_name.substring(0, 2).toUpperCase()
                      : (member.email || "").substring(0, 2).toUpperCase()}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[13px] font-medium text-[#171717] truncate">
                      {member.full_name || "User"}
                      {member.permission_role && (
                        <span className="ml-1 text-[11px] font-medium text-[#C95EBE]">
                          ({leadRoleLabel(member)})
                        </span>
                      )}
                    </p>
                    <p className="text-[11px] text-[#71717A] truncate">{member.email}</p>
                  </div>
                </button>
              ))
            ) : (
              <div className="px-3 py-2 text-[13px] text-[#71717A] text-center">
                {search.trim() ? "No matching members" : "No members available"}
              </div>
            )}
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

// --- Internal Row Component ---
const DynamicProjectDataRow = React.memo(({
  item,
  isSelected,
  onToggleSelect,
  onRowClick,
  onUpdateStatus,
  onUpdateContract,
  isActionMenuOpen,
  onToggleActionMenu,
  index,
  totalRows,
  actionMenuPosition,
  setActionMenuRef,
  onActionShare,
  onActionRename,
  onActionDelete,
  onActionDetails,
  onActionNotes,
  onActionArchive,
  onActionLeave,
  onActionTransferOwnership,
  onLockedAction,
  activeColumns,
  columnDefs,
}) => {
  const [isEditingContract, setIsEditingContract] = useState(false);
  const [isSavingContract, setIsSavingContract] = useState(false);
  const [editContractValue, setEditContractValue] = useState("");
  const savedContract = useRef(false);

  const startEditingContract = (e, item) => {
    e.stopPropagation();
    savedContract.current = false;
    setIsEditingContract(true);
    setEditContractValue(
      item.contract_value === "_" ? "" : formatContractValue(item.contract_value)
    );
  };

  const saveContractValue = async () => {
    // Guard so Enter (explicit save) and the blur it triggers don't both fire the API
    if (savedContract.current) return;
    savedContract.current = true;
    setIsEditingContract(false);
    if (editContractValue !== formatContractValue(item.contract_value)) {
      setIsSavingContract(true);
      try {
        await onUpdateContract(item.id, editContractValue);
      } finally {
        setIsSavingContract(false);
      }
    }
  };

  const cancelEditingContract = () => {
    savedContract.current = true;
    setIsEditingContract(false);
  };

  // Live-format the contract value with commas as the user types.
  const handleContractValueChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");
    setEditContractValue(raw ? `$${addThousandsSeparators(raw)}` : "");
  };

  const rowActions = {
    isEditingContract,
    isSavingContract,
    editContractValue,
    setEditContractValue,
    handleContractValueChange,
    saveContractValue,
    cancelEditingContract,
    startEditingContract,
    onUpdateStatus,
    onOpenNotes: () => onActionNotes(item),
    isSelected,
    onToggleSelect,
  };

  // Oversight rows can't be opened — the project page would 403 on its first
  // request — so the row click explains why instead of navigating into a
  // broken page.
  const locked = hasNoAccess(item);

  return (
    <tr
      // A locked row is styled read-only rather than only announcing itself
      // after you click: no pointer, no hover lift, and a faintly recessed
      // background. The toast is the fallback for someone who clicks anyway.
      className={`transition-colors ${
        locked ? "cursor-default [&>td]:!bg-[#FCFCFC]" : "cursor-pointer hover:bg-gray-50"
      }`}
      onClick={() => (locked ? onLockedAction(item) : onRowClick(item))}
    >
      {activeColumns.map((col) => columnDefs[col.name]?.cell(item, rowActions))}

      {/* Actions Cell Fixed Size */}
      <td
        style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
        className="px-3 py-1 relative border-b border-[#0000001A] bg-white text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          onClick={(e) => onToggleActionMenu(item, e)}
          className="cursor-pointer flex items-center justify-center w-8 h-8 action-button mx-auto rounded hover:bg-gray-100 transition-colors"
        >
          <DotsIcon />
        </div>
        {isActionMenuOpen && (
          <ActionMenuPopover
            position={actionMenuPosition}
            menuRef={setActionMenuRef}
            isOwner={isOwnerRow(item)}
            canEdit={canEditRow(item)}
            hasAccess={!locked}
            canTransfer={canTransferOwnership(item)}
            ownerName={item.owner?.name || item.owner?.email || ""}
            onProjectDetails={(e) => { e.stopPropagation(); onActionDetails(item); }}
            isLastRow={index >= totalRows - 5 && totalRows > 5}
            onShare={(e) => { e.stopPropagation(); onActionShare(item); }}
            onAddNotes={(e) => { e.stopPropagation(); onActionNotes(item); }}
            hasNote={!!(item.note && String(item.note).trim())}
            onRename={(e) => { e.stopPropagation(); e.preventDefault(); onActionRename(item); }}
            onArchive={(e) => { e.stopPropagation(); e.preventDefault(); onActionArchive(item); }}
            onDelete={(e) => { e.stopPropagation(); e.preventDefault(); onActionDelete(item); }}
            onLeave={(e) => { e.stopPropagation(); e.preventDefault(); onActionLeave(item); }}
            onTransferOwnership={(e) => { e.stopPropagation(); e.preventDefault(); onActionTransferOwnership(item); }}
          />
        )}
      </td>
    </tr>
  );
});

// --- Main Table Component ---
const ProjectDataTable = ({
  columnPreferences,
  isAllChecked,
  handleSelectAll,
  // How many of the visible rows the user may actually select (owned rows only).
  selectableCount = 0,
  filteredProjects,
  loading,
  currentProjects,
  selectedProjects,
  handleCheckboxChange,
  handleRowClick,
  onUpdateStatus,
  handleUpdateContractValue,
  onUpdateDeadline,
  onUpdateDateSubmitted,
  onUpdateProjectLead,
  orgMembers = [],
  canManageLead = false,
  onSetLeadMember,
  isActionMenuOpen,
  toggleActionMenu,
  actionMenuPosition,
  actionMenuRefs,
  handleActionShare,
  handleActionRename,
  handleActionDelete,
  handleActionDetails,
  handleActionNotes,
  handleActionArchive,
  handleActionLeave,
  handleActionTransferOwnership,
  // Fired when the user interacts with a project they can see but have no
  // access to (org-admin oversight rows). Shows the "ask the owner" toast.
  onLockedAction = () => {},
  // { title, body } for the empty table — the caller knows WHY the list is
  // empty (no projects at all / filtered out / looking at the wrong slice).
  emptyState = {
    title: "No projects yet",
    body: "Create your first project to get started. Your projects will show up here once added.",
  },
  // Off where there is no bulk action to select for (the dashboard).
  selectable = true,
  containerClassName = "w-full h-full overflow-auto custom-scrollbar relative",
}) => {
  const [columnWidths, setColumnWidths] = useState(() => {
    try {
      const savedWidths = localStorage.getItem("projectTable_columnWidths_v2");
      return savedWidths ? JSON.parse(savedWidths) : {};
    } catch (error) {
      return {};
    }
  });

  // --- NEW: Calendar State & Refs ---
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const [editingProject, setEditingProject] = useState(null);
  // Which date column the calendar is currently editing: "deadline" | "date_submitted".
  const [editingField, setEditingField] = useState("deadline");
  const calendarRef = useRef(null);

  // --- Tags: modal state + silent refetch from the shared store ---
  const fetchProjects = useProjectsStore((s) => s.fetchProjects);
  const [tagModalProjectId, setTagModalProjectId] = useState(null);
  // Project whose tags are being saved/refreshed (shows an "Applying…" cell state).
  const [applyingTagProjectId, setApplyingTagProjectId] = useState(null);
  // Project whose lead is being set/updated (shows an "Applying…" cell state).
  const [applyingLeadProjectId, setApplyingLeadProjectId] = useState(null);
  const openTagModalFor = useCallback((id) => setTagModalProjectId(id), []);

   // --- NEW: Calendar Handlers ---
   // `field` selects which date column we're editing ("deadline" | "date_submitted").
   const handleOpenCalendar = useCallback((e, item, field = "deadline") => {
    e.stopPropagation();
    e.preventDefault();
    const rect = e.currentTarget.getBoundingClientRect();
    // Position calendar slightly below the clicked date cell
    setCalendarPosition({
        top: rect.bottom + 5,
        left: rect.left
    });
    setEditingProject(item);
    setEditingField(field);
    setCalendarOpen(true);
  }, []);

  const handleSaveDate = async (selectedRange) => {
    if (!selectedRange.start || !editingProject) return false;
    try {
      const date = selectedRange.start;
      const yyyy = date.getFullYear();
      // getMonth() is 0-indexed, so we add 1. padStart ensures 2 digits (e.g., '04')
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      // Standard API format is YYYY-MM-DD.
      // Note: If your backend strictly requires YYYY-DD-MM as you mentioned, change this to `${yyyy}-${dd}-${mm}`
      const formattedDate = `${yyyy}-${mm}-${dd}`;

      if (editingField === "date_submitted") {
        if (onUpdateDateSubmitted) {
          await onUpdateDateSubmitted(editingProject.id, formattedDate);
        }
      } else if (onUpdateDeadline) {
        await onUpdateDeadline(editingProject.id, formattedDate);
      }
      return true;
    } catch (error) {
      console.error("Failed to save date", error);
      return false;
    }
  };
  
  // --- NEW: Calendar Click-Outside & Scroll Effects ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarOpen && calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [calendarOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (calendarOpen) setCalendarOpen(false);
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [calendarOpen]);

  const handleResize = useCallback((colName, e) => {
    e.preventDefault();
    e.stopPropagation();

    const thElement = e.target.closest("th");
    const startWidth = thElement ? thElement.getBoundingClientRect().width : 150;
    const startX = e.clientX;

    const onMouseMove = (moveEvent) => {
      const minW = colName === "projectName" ? 250 : 120;
      const newWidth = Math.max(minW, startWidth + (moveEvent.clientX - startX));
      setColumnWidths((prev) => ({ ...prev, [colName]: newWidth }));
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "default";

      setColumnWidths((latestWidths) => {
        localStorage.setItem("projectTable_columnWidths_v2", JSON.stringify(latestWidths));
        return latestWidths;
      });
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    document.body.style.cursor = "col-resize";
  }, []);

  const getColStyle = useCallback((colName) => {
    return columnWidths[colName]
      ? {
          width: columnWidths[colName],
          minWidth: columnWidths[colName],
          maxWidth: columnWidths[colName],
        }
      : {};
  }, [columnWidths]);

  // Must stay in sync with _COLUMN_DEFAULTS["rfp_folders"] in the backend
  // (rfp/views/folders.py) — this is only the fallback used before the saved
  // preferences arrive.
  const defaultCols = [
    { name: "name", order: 0, visible: true },
    { name: "owner", order: 1, visible: true },
    { name: "access", order: 2, visible: true },
    { name: "rfp_status", order: 3, visible: true },
    { name: "deadline", order: 4, visible: true },
    { name: "project_lead", order: 5, visible: true },
    { name: "date_submitted", order: 6, visible: true },
    { name: "contract_value", order: 7, visible: true },
    { name: "updated_at", order: 8, visible: true },
    { name: "tags", order: 9, visible: true },
    { name: "shared_to", order: 10, visible: true },
    { name: "note", order: 11, visible: true },
    { name: "created_at", order: 12, visible: true },
    { name: "shared_by", order: 13, visible: false },
    { name: "shared_on", order: 14, visible: false },
  ];

  // Saved preferences can name a column this build no longer renders (a rename,
  // a rollback, an older tab's key). Dropping those here keeps the header, the
  // cells and the empty-state colSpan counting the same set of columns.
  const activeColumns = useMemo(() => {
    return (columnPreferences && columnPreferences.length > 0 ? columnPreferences : defaultCols)
      .filter((col) => col.visible === true || col.visible === "true")
      .filter((col) => KNOWN_COLUMN_NAMES.has(col.name))
      .sort((a, b) => a.order - b.order);
  }, [columnPreferences]);

  const visibleColCount = activeColumns.length + 1;

  // The table's minimum width used to be a hardcoded 1540px, which no longer
  // fits now that the merged view can show up to 15 columns — and which forced
  // a pointless horizontal scrollbar when most columns were hidden. Derive it
  // from the columns actually on screen instead, honouring any manual resizes.
  const tableMinWidth = useMemo(() => {
    const columnsTotal = activeColumns.reduce(
      (total, col) =>
        total + (columnWidths[COLUMN_RESIZE_KEYS[col.name]] || DEFAULT_COL_WIDTHS[col.name] || 140),
      0
    );
    return columnsTotal + ACTIONS_COL_WIDTH;
  }, [activeColumns, columnWidths]);

  // Click handler for a cell the current user may not edit.
  //
  // Locked rows (org-admin oversight) swallow the click and explain themselves.
  // Read-only-but-accessible rows — a reviewer on a shared project — must let
  // the click BUBBLE, otherwise a reviewer clicking Status or a date would get
  // nothing at all instead of opening the project like any other cell does.
  const blockedClick = useCallback((item, e) => {
    if (!hasNoAccess(item)) return;
    e.stopPropagation();
    onLockedAction(item);
  }, [onLockedAction]);

  // For cells that were always click-swallowing regardless of permission (tags,
  // the members avatars) — they own their click, they just also need to explain
  // themselves on a locked row.
  const selfContainedCellClick = useCallback((item, e) => {
    e.stopPropagation();
    if (hasNoAccess(item)) onLockedAction(item);
  }, [onLockedAction]);

  // --- STRICT PIXEL WIDTHS FOR DATA COLUMNS ---
  // Note: bg-[#F7F7F7] and bg-clip-padding applied to every `th` to prevent bleeding
  const columnDefs = useMemo(() => ({
    name: {
      header: (
        <th
          key="name"
          style={columnWidths.projectName ? getColStyle("projectName") : { width: "280px", minWidth: "280px" }}
          className={`rounded-tl-lg bg-[#F7F7F7] bg-clip-padding relative px-3 py-2 text-left text-[#00000080] font-outfit text-[14px] font-semibold  border-r border-[#0000001A]`}
        >
          <div className="flex items-center gap-3 w-full h-full">
            {selectable && (
            <div className="shrink-0 w-[24px]">
              {/* Only owned rows can be selected, so "select all" is dead when
                  the visible list is entirely projects shared with the user. */}
              <Checkbox checked={isAllChecked} onChange={handleSelectAll} disabled={selectableCount === 0} showLabel={false} size="md" />
            </div>
            )}
            <span className="truncate block pr-2">Project Name</span>
          </div>
          <div onMouseDown={(e) => handleResize("projectName", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item, rowActions) => (
        <td
          key={`name-${item.id}`}
          style={columnWidths.projectName ? getColStyle("projectName") : { width: "280px", minWidth: "280px" }}
          className={`px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white`}
        >
          <div className="flex items-center gap-3 w-full h-full min-w-0">
            {/* Selection drives the bulk Delete action, which only an owner may
                perform — shared rows are not selectable. */}
            {selectable && (
            <div className="shrink-0 w-[24px]" onClick={(e) => e.stopPropagation()} title={!isOwnerRow(item) ? "Only the project owner can delete this project" : undefined}>
              <Checkbox id={`checkbox-${item.id}`} checked={rowActions.isSelected} onChange={(val, e) => { if (e) e.stopPropagation(); rowActions.onToggleSelect(item.id, item.key); }} disabled={!item.id || !isOwnerRow(item)} showLabel={false} size="md" />
            </div>
            )}
            {/* Muted on a locked row so it reads as read-only at a glance. */}
            <span className={`truncate block pr-2 ${hasNoAccess(item) ? "text-[#A1A1AA]" : ""}`} title={item.name}>{item.name || "_"}</span>
          </div>
        </td>
      ),
    },
      rfp_status: {
      header: (
        <th key="rfp_status" style={getColStyle("status")} className={`${!columnWidths.status ? "w-[170px] min-w-[170px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Status
          <div onMouseDown={(e) => handleResize("status", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item, rowActions) => (
        <td key={`rfp_status-${item.id}`} style={getColStyle("status")} className={`${!columnWidths.status ? "w-[170px] min-w-[170px]" : ""} px-3 py-1 border-b border-r border-[#0000001A] bg-white text-left overflow-hidden`} onClick={(e) => { if (canEditRow(item)) { e.stopPropagation(); rowActions.onUpdateStatus(item); } else { blockedClick(item, e); } }}>
          <div className="w-full flex items-center">
            {renderStatusPill(item.status)}
          </div>
        </td>
      ),
    },
    owner: {
      header: (
        <th key="owner" style={getColStyle("owner")} className={`${!columnWidths.owner ? "w-[180px] min-w-[180px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          Owner
          <div onMouseDown={(e) => handleResize("owner", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => {
        // "You" reads faster than your own name on the rows you own, which are
        // the majority for most users.
        const ownerName = isOwnerRow(item)
          ? "You"
          : item.owner?.name || item.owner?.email || "_";
        return (
          <td key={`owner-${item.id}`} style={getColStyle("owner")} className={`${!columnWidths.owner ? "w-[180px] min-w-[180px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`} title={item.owner?.email || undefined}>
            {ownerName}
          </td>
        );
      },
    },
    access: {
      header: (
        <th key="access" style={getColStyle("access")} className={`${!columnWidths.access ? "w-[130px] min-w-[130px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          My Access
          <div onMouseDown={(e) => handleResize("access", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td key={`access-${item.id}`} style={getColStyle("access")} className={`${!columnWidths.access ? "w-[130px] min-w-[130px]" : ""} px-3 py-1 text-left border-b border-r border-[#0000001A] bg-white overflow-hidden`}>
          {renderAccessPill(item)}
        </td>
      ),
    },
    shared_by: {
      header: (
        <th key="shared_by" style={getColStyle("sharedBy")} className={`${!columnWidths.sharedBy ? "w-[190px] min-w-[190px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          Shared By
          <div onMouseDown={(e) => handleResize("sharedBy", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      // Empty on your own projects — nobody shared them with you.
      cell: (item) => (
        <td key={`shared_by-${item.id}`} style={getColStyle("sharedBy")} className={`${!columnWidths.sharedBy ? "w-[190px] min-w-[190px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`} title={item.shared_by || undefined}>
          {item.shared_by || "_"}
        </td>
      ),
    },
    shared_on: {
      header: (
        <th key="shared_on" style={getColStyle("sharedOn")} className={`${!columnWidths.sharedOn ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          Shared On
          <div onMouseDown={(e) => handleResize("sharedOn", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td key={`shared_on-${item.id}`} style={getColStyle("sharedOn")} className={`${!columnWidths.sharedOn ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
          {formatDate(item.shared_on)}
        </td>
      ),
    },
    contract_value: {
      header: (
        <th key="contract_value" style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Contract Value
          <div onMouseDown={(e) => handleResize("contractValue", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item, rowActions) => (
        <td key={`contract_value-${item.id}`} style={getColStyle("contractValue")} className={`${!columnWidths.contractValue ? "w-[150px] min-w-[150px]" : ""} px-3 py-1 text-[#52525B] font-outfit text-[15px] font-medium border-b border-r border-[#0000001A] bg-white text-left`}>
          {rowActions.isSavingContract ? (
            <div className="flex items-center gap-1.5 px-2 py-1 text-[#A1A1AA] font-outfit text-[15px] font-medium leading-normal">
              
              Saving…
            </div>
          ) : rowActions.isEditingContract ? (
            <input autoFocus type="text" className="block w-full px-2 py-1 border border-[#C95EBE] rounded-md outline-none bg-white text-[#171717] font-outfit text-[15px] font-medium leading-normal box-border" value={rowActions.editContractValue} onChange={rowActions.handleContractValueChange} onBlur={rowActions.saveContractValue} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); rowActions.saveContractValue(); } else if (e.key === "Escape") { e.preventDefault(); rowActions.cancelEditingContract(); } }} onClick={(e) => e.stopPropagation()} />
          ) : canEditRow(item) ? (
            <div className="block w-full px-2 py-1 rounded-md cursor-text hover:bg-[#F4F4F5] transition-colors border border-transparent leading-normal box-border truncate" onClick={(e) => rowActions.startEditingContract(e, item)}>{formatContractValue(item.contract_value)}</div>
          ) : (
            <div className="block w-full px-2 py-1 border border-transparent leading-normal box-border truncate" onClick={(e) => blockedClick(item, e)}>{formatContractValue(item.contract_value)}</div>
          )}
        </td>
      ),
    },
    deadline: {
      header: (
        <th key="deadline" style={getColStyle("bidEndDate")} className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Bid End Date
          <div onMouseDown={(e) => handleResize("bidEndDate", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td
          key={`deadline-${item.id}`}
          style={getColStyle("bidEndDate")}
          className={`${!columnWidths.bidEndDate ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white ${canEditRow(item) ? "cursor-pointer hover:bg-gray-50" : ""}`}
          onClick={(e) => { if (canEditRow(item)) handleOpenCalendar(e, item); else blockedClick(item, e); }}
        >
          {formatDeadlineDate(item.deadline)}
        </td>
      ),
    },
    project_lead: {
      header: (
        <th key="project_lead" style={getColStyle("projectLead")} className={`${!columnWidths.projectLead ? "w-[200px] min-w-[200px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Project Lead
          <div onMouseDown={(e) => handleResize("projectLead", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td
          key={`project_lead-${item.id}`}
          style={getColStyle("projectLead")}
          className={`${!columnWidths.projectLead ? "w-[200px] min-w-[200px]" : ""} px-3 py-1 text-left border-b border-r border-[#0000001A] bg-white`}
        >
          <ProjectLeadCell
            value={item.project_lead}
            members={orgMembers}
            // Assigning a lead also shares the project, so it stays owner-only.
            canManage={canManageLead && isOwnerRow(item)}
            isApplying={applyingLeadProjectId === item.id}
            onPick={async (member) => {
              if (!onSetLeadMember) return;
              setApplyingLeadProjectId(item.id);
              try {
                await onSetLeadMember(item, member);
              } finally {
                setApplyingLeadProjectId(null);
              }
            }}
          />
        </td>
      ),
    },
    date_submitted: {
      header: (
        <th key="date_submitted" style={getColStyle("dateSubmitted")} className={`${!columnWidths.dateSubmitted ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Date Submitted
          <div onMouseDown={(e) => handleResize("dateSubmitted", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td
          key={`date_submitted-${item.id}`}
          style={getColStyle("dateSubmitted")}
          className={`${!columnWidths.dateSubmitted ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white ${canEditRow(item) ? "cursor-pointer hover:bg-gray-50" : ""}`}
          onClick={(e) => { if (canEditRow(item)) handleOpenCalendar(e, item, "date_submitted"); else blockedClick(item, e); }}
        >
          {formatDeadlineDate(item.date_submitted)}
        </td>
      ),
    },
    tags: {
      header: (
        <th key="tags" style={getColStyle("tags")} className={`${!columnWidths.tags ? "w-[220px] min-w-[220px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Tags
          <div onMouseDown={(e) => handleResize("tags", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td
          key={`tags-${item.id}`}
          style={getColStyle("tags")}
          className={`${!columnWidths.tags ? "w-[220px] min-w-[220px]" : ""} px-3 py-1 text-left border-b border-r border-[#0000001A] bg-white`}
          onClick={(e) => selfContainedCellClick(item, e)}
        >
          {/* Tags belong to the project owner; shared rows show them read-only. */}
          <DynamicTags
            tags={item.tags || []}
            darkenColor={darkenColor}
            openTagModalFor={openTagModalFor}
            itemId={item.id}
            isApplying={applyingTagProjectId === item.id}
            readOnly={!isOwnerRow(item)}
          />
        </td>
      ),
    },
    shared_to: {
      header: (
        <th key="shared_to" style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Shared To
          <div onMouseDown={(e) => handleResize("sharedTo", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td key={`shared_to-${item.id}`} style={getColStyle("sharedTo")} className={`${!columnWidths.sharedTo ? "w-[160px] min-w-[160px]" : ""} px-2 py-1 align-middle border-b border-r border-[#0000001A] bg-white min-w-0 text-left`} onClick={(e) => selfContainedCellClick(item, e)}>
          <DynamicAvatars users={item.shared_to} />
        </td>
      ),
    },
    note: {
      header: (
        <th key="note" style={getColStyle("notes")} className={`${!columnWidths.notes ? "w-[240px] min-w-[240px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          Notes
          <div onMouseDown={(e) => handleResize("notes", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item, rowActions) => {
        const noteText = item.note && String(item.note).trim() ? String(item.note).trim() : "";
        // Reviewers on a shared project read the note but can't open the editor.
        const editable = canEditRow(item);
        const openNotes = (e) => {
          if (editable) {
            e.stopPropagation();
            rowActions.onOpenNotes();
          } else {
            blockedClick(item, e);
          }
        };
        return (
          <td
            key={`note-${item.id}`}
            style={getColStyle("notes")}
            title={noteText || undefined}
            className={`${!columnWidths.notes ? "w-[240px] min-w-[240px]" : ""} px-3 py-1 text-left font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}
          >
            {noteText ? (
              <span
                className={`text-[#52525B] transition-colors ${editable ? "cursor-pointer hover:text-[#C95EBE]" : ""}`}
                onClick={openNotes}
              >
                {noteText}
              </span>
            ) : (
              <span
                className={`text-[#A1A1AA] italic transition-colors ${editable ? "cursor-pointer hover:text-[#C95EBE]" : ""}`}
                onClick={openNotes}
              >
                No notes available
              </span>
            )}
          </td>
        );
      },
    },
    updated_at: {
      header: (
        <th key="updated_at" style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold border-r border-[#0000001A]`}>
          Last Edited
          <div onMouseDown={(e) => handleResize("lastEdited", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td key={`updated_at-${item.id}`} style={getColStyle("lastEdited")} className={`${!columnWidths.lastEdited ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
          {formatDate(item.updated_at)}
        </td>
      ),
    },
    created_at: {
      header: (
        <th key="created_at" style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} bg-[#F7F7F7] bg-clip-padding relative px-3 text-left text-[#00000080] font-outfit text-[13px] font-semibold  border-r border-[#0000001A]`}>
          Created On
          <div onMouseDown={(e) => handleResize("createdOn", e)} className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#C95EBE] transition-colors z-10" />
        </th>
      ),
      cell: (item) => (
        <td key={`created_at-${item.id}`} style={getColStyle("createdOn")} className={`${!columnWidths.createdOn ? "w-[140px] min-w-[140px]" : ""} px-3 py-1 text-left text-[#52525B] font-outfit text-[15px] font-medium truncate border-b border-r border-[#0000001A] bg-white`}>
          {formatDate(item.created_at)}
        </td>
      ),
    },
  }), [selectable, columnWidths, getColStyle, handleResize, isAllChecked, handleSelectAll, selectableCount, handleOpenCalendar, openTagModalFor, applyingTagProjectId, applyingLeadProjectId, orgMembers, canManageLead, onSetLeadMember, blockedClick, selfContainedCellClick]);

  return (
    <div className={containerClassName}>
      <table style={{ minWidth: `${tableMinWidth}px` }} className="w-full table-fixed text-sm text-left border-separate border-spacing-0 relative">  <thead className="h-10 text-[#1E1E1E] font-medium sticky top-0 z-[100] [&_th]:border-b [&_th]:border-[#0000001A]">
          <tr>
            {activeColumns.map((col) => columnDefs[col.name]?.header)}

            {/* Actions Header Locked */}
            <th
              style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
              className="rounded-tr-lg bg-[#F7F7F7] bg-clip-padding px-3 text-center text-[#00000080] font-outfit text-[15px] font-semibold relative"
            >
              Actions
            </th>
          </tr>
        </thead>

        <tbody className="bg-white">
          {loading ? (
            Array.from({ length: 8 }).map((_, rowIdx) => (
              <tr key={`skeleton-${rowIdx}`} className="animate-pulse">
                {activeColumns.map((col, colIdx) => (
                  <td
                    key={`skeleton-${rowIdx}-${col.name}`}
                    className="px-3 py-[14px] border-b border-r border-[#0000001A] bg-white"
                  >
                    <div
                      className="h-3.5 rounded bg-[#E5E7EB]"
                      style={{ width: `${[70, 55, 85, 45, 60, 50, 75][colIdx % 7]}%` }}
                    />
                  </td>
                ))}
                {/* Actions column */}
                <td className="px-3 py-[14px] border-b border-[#0000001A] bg-white">
                  <div className="h-3.5 w-6 rounded bg-[#E5E7EB] mx-auto" />
                </td>
              </tr>
            ))
          ) : filteredProjects.length > 0 ? (
            currentProjects.map((item, index) => (
              <DynamicProjectDataRow
                key={item.id || index}
                item={item}
                index={index}
                totalRows={currentProjects.length}
                isSelected={selectedProjects.includes(item.id)}
                onToggleSelect={handleCheckboxChange}
                onRowClick={handleRowClick}
                onUpdateStatus={onUpdateStatus}
                onUpdateContract={handleUpdateContractValue}
                isActionMenuOpen={isActionMenuOpen === item.id}
                onToggleActionMenu={toggleActionMenu}
                actionMenuPosition={actionMenuPosition}
                setActionMenuRef={(el) => { if (el) actionMenuRefs.current[item.id] = el; }}
                onActionShare={handleActionShare}
                onActionRename={handleActionRename}
                onActionDelete={handleActionDelete}
                onActionDetails={handleActionDetails}
                onActionNotes={handleActionNotes}
                onActionArchive={handleActionArchive}
                onActionLeave={handleActionLeave}
                onActionTransferOwnership={handleActionTransferOwnership}
                onLockedAction={onLockedAction}
                activeColumns={activeColumns}
                columnDefs={columnDefs}
              />
            ))
          ) : (
            <tr className="hover:!bg-white hover:!shadow-none">
              <td colSpan={visibleColCount} className="py-20 text-center text-black border-b border-[#0000001A]">
                <img src="/no-contracts.svg" alt="No Data" className="mx-auto mb-4 w-32" />
                <p className="text-[17px] font-outfit font-semibold text-[#1A1A1A] mb-1.5">
                  {emptyState.title}
                </p>
                <p className="text-[14px] font-outfit text-[#71717A] max-w-[380px] mx-auto leading-relaxed">
                  {emptyState.body}
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {calendarOpen && (
        <DateCalendar
          isOpen={calendarOpen}
          position={calendarPosition}
          menuRef={calendarRef}
          onClose={() => setCalendarOpen(false)}
          onSave={handleSaveDate}
          initialDateRange={(() => {
            const raw = editingField === "date_submitted"
              ? editingProject?.date_submitted
              : editingProject?.deadline;
            return raw && raw !== "_" ? { start: parseDeadlineDate(raw) } : null;
          })()}
        />
      )}

      <ProjectTagModal
        isOpen={tagModalProjectId !== null}
        onClose={() => setTagModalProjectId(null)}
        documentId={tagModalProjectId}
        displayedFiles={filteredProjects}
        onTagUpdate={async () => {
          const pid = tagModalProjectId;
          if (pid == null) return;
          setApplyingTagProjectId(pid);
          try {
            await fetchProjects(true);
          } finally {
            setApplyingTagProjectId(null);
          }
        }}
      />
    </div>
  );
};

export default ProjectDataTable;